export default "__VITE_ASSET__CCaomZ9f__"